import { useEffect } from 'react';

import { TkOrderListing } from '../components/OrderTable/types.ts';
import { useCreateAllTrainingOrders } from './useCreateAllTrainingOrders.ts';

export const useBackfillOrders = (orders: TkOrderListing[]) => {
  const createAllTrainingOrders = useCreateAllTrainingOrders(true);

  useEffect(() => {
    const missingTrainingOrders = orders.filter(({ isTraining }) => isTraining).length < 3;

    if (missingTrainingOrders) {
      createAllTrainingOrders();
    }
  }, []);
};
